import { render, staticRenderFns } from "./CPDueDiligencePlannedInvestmentVolume.vue?vue&type=template&id=5c3c8032&scoped=true&"
import script from "./CPDueDiligencePlannedInvestmentVolume.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligencePlannedInvestmentVolume.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligencePlannedInvestmentVolume.vue?vue&type=style&index=0&id=5c3c8032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3c8032",
  null
  
)

export default component.exports